/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Game studio API
 * Game studio API documentation OAS.
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiTipsFulltextParams,
  GetApiTipsParams,
  GetApiTipsTipOfDayParams,
  TipDetailDto,
  TipDetailDtoPaginatedList
} from '../../backoffice-schemas';

import getApiTipsMutator from '../../../lib/customInstance';
import getApiTipsFulltextMutator from '../../../lib/customInstance';
import getApiTipsIdMutator from '../../../lib/customInstance';
import getApiTipsSlugSlugMutator from '../../../lib/customInstance';
import getApiTipsTipOfDayMutator from '../../../lib/customInstance';
import getApiTipsSlugsMutator from '../../../lib/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getApiTips = (
    params?: GetApiTipsParams,
 options?: SecondParameter<typeof getApiTipsMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsMutator<TipDetailDtoPaginatedList>(
      {url: `https://api.staging.gocore.gg/api/Tips`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiTipsQueryKey = (params?: GetApiTipsParams,) => {
    return [`https://api.staging.gocore.gg/api/Tips`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiTipsQueryOptions = <TData = Awaited<ReturnType<typeof getApiTips>>, TError = unknown>(params?: GetApiTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTips>>> = ({ signal }) => getApiTips(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTips>>>
export type GetApiTipsQueryError = unknown


export function useGetApiTips<TData = Awaited<ReturnType<typeof getApiTips>>, TError = unknown>(
 params: undefined |  GetApiTipsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTips>>,
          TError,
          Awaited<ReturnType<typeof getApiTips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTips<TData = Awaited<ReturnType<typeof getApiTips>>, TError = unknown>(
 params?: GetApiTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTips>>,
          TError,
          Awaited<ReturnType<typeof getApiTips>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTips<TData = Awaited<ReturnType<typeof getApiTips>>, TError = unknown>(
 params?: GetApiTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTips<TData = Awaited<ReturnType<typeof getApiTips>>, TError = unknown>(
 params?: GetApiTipsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTips>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiTipsFulltext = (
    params?: GetApiTipsFulltextParams,
 options?: SecondParameter<typeof getApiTipsFulltextMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsFulltextMutator<TipDetailDtoPaginatedList>(
      {url: `https://api.staging.gocore.gg/api/Tips/fulltext`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiTipsFulltextQueryKey = (params?: GetApiTipsFulltextParams,) => {
    return [`https://api.staging.gocore.gg/api/Tips/fulltext`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiTipsFulltextQueryOptions = <TData = Awaited<ReturnType<typeof getApiTipsFulltext>>, TError = unknown>(params?: GetApiTipsFulltextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsFulltextMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsFulltextQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTipsFulltext>>> = ({ signal }) => getApiTipsFulltext(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsFulltextQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTipsFulltext>>>
export type GetApiTipsFulltextQueryError = unknown


export function useGetApiTipsFulltext<TData = Awaited<ReturnType<typeof getApiTipsFulltext>>, TError = unknown>(
 params: undefined |  GetApiTipsFulltextParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsFulltext>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsFulltext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsFulltextMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsFulltext<TData = Awaited<ReturnType<typeof getApiTipsFulltext>>, TError = unknown>(
 params?: GetApiTipsFulltextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsFulltext>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsFulltext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsFulltextMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsFulltext<TData = Awaited<ReturnType<typeof getApiTipsFulltext>>, TError = unknown>(
 params?: GetApiTipsFulltextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsFulltextMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTipsFulltext<TData = Awaited<ReturnType<typeof getApiTipsFulltext>>, TError = unknown>(
 params?: GetApiTipsFulltextParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsFulltext>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsFulltextMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsFulltextQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiTipsId = (
    id: string,
 options?: SecondParameter<typeof getApiTipsIdMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsIdMutator<TipDetailDto>(
      {url: `https://api.staging.gocore.gg/api/Tips/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiTipsIdQueryKey = (id?: string,) => {
    return [`https://api.staging.gocore.gg/api/Tips/${id}`] as const;
    }

    
export const getGetApiTipsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiTipsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsIdMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTipsId>>> = ({ signal }) => getApiTipsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTipsId>>>
export type GetApiTipsIdQueryError = unknown


export function useGetApiTipsId<TData = Awaited<ReturnType<typeof getApiTipsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsId>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsIdMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsId<TData = Awaited<ReturnType<typeof getApiTipsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsId>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsId<TData = Awaited<ReturnType<typeof getApiTipsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsIdMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTipsId<TData = Awaited<ReturnType<typeof getApiTipsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsId>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsIdMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiTipsSlugSlug = (
    slug: string,
 options?: SecondParameter<typeof getApiTipsSlugSlugMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsSlugSlugMutator<TipDetailDto>(
      {url: `https://api.staging.gocore.gg/api/Tips/slug/${slug}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiTipsSlugSlugQueryKey = (slug?: string,) => {
    return [`https://api.staging.gocore.gg/api/Tips/slug/${slug}`] as const;
    }

    
export const getGetApiTipsSlugSlugQueryOptions = <TData = Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError = unknown>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugSlugMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsSlugSlugQueryKey(slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTipsSlugSlug>>> = ({ signal }) => getApiTipsSlugSlug(slug, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsSlugSlugQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTipsSlugSlug>>>
export type GetApiTipsSlugSlugQueryError = unknown


export function useGetApiTipsSlugSlug<TData = Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError = unknown>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsSlugSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsSlugSlug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsSlugSlugMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsSlugSlug<TData = Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsSlugSlug>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsSlugSlug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsSlugSlugMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsSlugSlug<TData = Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugSlugMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTipsSlugSlug<TData = Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugSlug>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugSlugMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsSlugSlugQueryOptions(slug,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiTipsTipOfDay = (
    params: GetApiTipsTipOfDayParams,
 options?: SecondParameter<typeof getApiTipsTipOfDayMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsTipOfDayMutator<TipDetailDto>(
      {url: `https://api.staging.gocore.gg/api/Tips/tip-of-day`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetApiTipsTipOfDayQueryKey = (params?: GetApiTipsTipOfDayParams,) => {
    return [`https://api.staging.gocore.gg/api/Tips/tip-of-day`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiTipsTipOfDayQueryOptions = <TData = Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError = unknown>(params: GetApiTipsTipOfDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsTipOfDayMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsTipOfDayQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTipsTipOfDay>>> = ({ signal }) => getApiTipsTipOfDay(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsTipOfDayQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTipsTipOfDay>>>
export type GetApiTipsTipOfDayQueryError = unknown


export function useGetApiTipsTipOfDay<TData = Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError = unknown>(
 params: GetApiTipsTipOfDayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsTipOfDay>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsTipOfDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsTipOfDayMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsTipOfDay<TData = Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError = unknown>(
 params: GetApiTipsTipOfDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsTipOfDay>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsTipOfDay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsTipOfDayMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsTipOfDay<TData = Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError = unknown>(
 params: GetApiTipsTipOfDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsTipOfDayMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTipsTipOfDay<TData = Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError = unknown>(
 params: GetApiTipsTipOfDayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsTipOfDay>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsTipOfDayMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsTipOfDayQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiTipsSlugs = (
    
 options?: SecondParameter<typeof getApiTipsSlugsMutator>,signal?: AbortSignal
) => {
      
      
      return getApiTipsSlugsMutator<string[]>(
      {url: `https://api.staging.gocore.gg/api/Tips/slugs`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiTipsSlugsQueryKey = () => {
    return [`https://api.staging.gocore.gg/api/Tips/slugs`] as const;
    }

    
export const getGetApiTipsSlugsQueryOptions = <TData = Awaited<ReturnType<typeof getApiTipsSlugs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugsMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiTipsSlugsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTipsSlugs>>> = ({ signal }) => getApiTipsSlugs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiTipsSlugsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTipsSlugs>>>
export type GetApiTipsSlugsQueryError = unknown


export function useGetApiTipsSlugs<TData = Awaited<ReturnType<typeof getApiTipsSlugs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsSlugs>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsSlugsMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsSlugs<TData = Awaited<ReturnType<typeof getApiTipsSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTipsSlugs>>,
          TError,
          Awaited<ReturnType<typeof getApiTipsSlugs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApiTipsSlugsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiTipsSlugs<TData = Awaited<ReturnType<typeof getApiTipsSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugsMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiTipsSlugs<TData = Awaited<ReturnType<typeof getApiTipsSlugs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTipsSlugs>>, TError, TData>>, request?: SecondParameter<typeof getApiTipsSlugsMutator>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiTipsSlugsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



